// extracted by mini-css-extract-plugin
export default {"popover":"qYM8R","warning":"xd1bf"};